/// 基础颜色体系，覆盖UED的二维调色板矩阵
/// 每种颜色包括亮度为500的对应色调主色和50~900的10种色阶颜色
/// 色调主色等同于改色调500亮度的颜色
/// 一维颜色配置
export class QColor {
    constructor(swatch) {
        this.swatch = swatch;
    }
    get shade1() {
        return this.swatch[1];
    }
    get shade2() {
        return this.swatch[2];
    }
    get shade3() {
        return this.swatch[3];
    }
    get shade4() {
        return this.swatch[4];
    }
    get shade5() {
        return this.swatch[5];
    }
    get shade6() {
        return this.swatch[6];
    }
    get shade7() {
        return this.swatch[7];
    }
    get shade8() {
        return this.swatch[8];
    }
    get shade9() {
        return this.swatch[9];
    }
    get shade10() {
        return this.swatch[10];
    }
}
const qunar = new QColor({
    1: '#00BECB',
    2: '#00CAD8',
    3: '#00D4E3',
    4: '#26DAE7',
    5: '#4DE1EB',
    6: '#73E7EF',
    7: '#99EDF3',
    8: '#BFF4F7',
    9: '#E6FAFC',
    10: '#F2FCFD'
});
const orange = new QColor({
    1: '#D95700',
    2: '#F26100',
    3: '#FF6600',
    4: '#FF7D26',
    5: '#FF944D',
    6: '#FFAB73',
    7: '#FFC299',
    8: '#FFD9BF',
    9: '#FFF0E6',
    10: '#FFF7F2'
});
const green = new QColor({
    1: '#009C67',
    2: '#00AE73',
    3: '#00B87A',
    4: '#26C28D',
    5: '#4DCDA2',
    6: '#73D8B5',
    7: '#99E2C9',
    8: '#BFEDDD',
    9: '#E6F8F1',
    10: '#F2FBF8'
});
const yellow = new QColor({
    1: '#D9AD00',
    2: '#F2C100',
    3: '#FFCC00',
    4: '#FFD326',
    5: '#FFDB4D',
    6: '#FFE373',
    7: '#FFEA99',
    8: '#FFF2BF',
    9: '#FFFAE6',
    10: '#FFFCF2'
});
const brown = new QColor({
    1: '#B9822E',
    2: '#C08E42',
    3: '#C79B58',
    4: '#CEA76C',
    5: '#D5B482',
    6: '#E2C79E',
    7: '#EAD4B2',
    8: '#F2E1C8',
    9: '#FAF2E2',
    10: '#FCF6EB'
});
const red = new QColor({
    1: '#D01B09',
    2: '#E91E0A',
    3: '#F5200A',
    4: '#F7412F',
    5: '#F86354',
    6: '#FA8478',
    7: '#FBA69D',
    8: '#FDC7C2',
    9: '#FEE9E7',
    10: '#FFF4F3'
});
const blue = new QColor({
    1: '#0072D1',
    2: '#007FE9',
    3: '#0086F6',
    4: '#2698F7',
    5: '#4DAAF8',
    6: '#73BCFA',
    7: '#99CEFB',
    8: '#BFE0FC',
    9: '#E6F3FE',
    10: '#F2F8FE'
});
const golden = new QColor({
    1: '#B7895C',
    2: '#CC9967',
    3: '#D7A16C',
    4: '#DDAF82',
    5: '#E3BD98',
    6: '#E9CBAE',
    7: '#EFD9C4',
    8: '#F5E8DA',
    9: '#FBF6F0',
    10: '#FDFAF8'
});
const silver = new QColor({
    1: '#797F8D',
    2: '#878E9E',
    3: '#8E95A6',
    4: '#9FA5B3',
    5: '#B0B5C1',
    6: '#C1C5CE',
    7: '#D2D5DB',
    8: '#E3E5E9',
    9: '#EDEFF2',
    10: '#F4F5F6'
});
const gray = new QColor({
    1: '#333333',
    2: '#666666',
    3: '#999999',
    4: '#AAAAAA',
    5: '#BBBBBB',
    6: '#CCCCCC',
    7: '#DDDDDD',
    8: '#E6E6E6',
    9: '#F2F2F2',
    10: '#FAFAFA'
});
// 纯色（黑色&白色）
const pure = new QColor({
    1: '#000000',
    2: '#FFFFFF'
});
export const palette = {
    qunar,
    orange,
    green,
    yellow,
    red,
    blue,
    golden,
    silver,
    gray,
    brown,
    pure
};
